module.exports = __webpack_public_path__ + "static/media/Pokana_OSA_Formoplast_GFO 2018.9adf9688.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Pokana_OSA_Formoplast_GFO 2018.pdf
// module id = 125
// module chunks = 0